// extracted by mini-css-extract-plugin
module.exports = {"shine":"SageShimmer_shine__1Ef5k","placeholderShimmer":"SageShimmer_placeholderShimmer__2QSbP"};